import React from "react";
import styles from "./styles.module.css";

const PopOver = (props) => {
  return <div className={styles.popoverContainerStyles}>{props.children}</div>;
};

export default PopOver;
